<template>
  <div v-if="isReadyToDraw">
    <div class="item-container" @click="goToCoupon(coupon)">
      <div class="item-img">
        <TheCouponThumbnail
          :imageUrl="masterCoupon?.thumbnail_image_url || defaultImageUrl"
        />
      </div>

      <div class="item-content">
        <TheCouponName :name="coupon?.name" />
      </div>

      <div class="item-btn">
        <img :src="require('@/assets/img/icon/svg/arrow-right.svg')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ItemIndexCoupons",
  props: {
    coupon: {
      type: Object,
      required: true,
    },
    isPastCoupon: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const isReadyToDraw = ref(false);
    const isLocal = process.env.NODE_ENV == "local" ? true : false;

    const masterCoupon = computed(() => props.coupon._masterCoupon);

    const defaultImageUrl = computed(() => {
      if (props.isPastCoupon) {
        return require(`@/assets/img/icon/svg/icon-coupon-gray.svg`);
      }

      return require(`@/assets/img/icon/svg/icon-coupon.svg`);
    });

    watchEffect(() => {
      if (props.coupon != null) {
        isReadyToDraw.value = true;
      }
    });

    const goToCoupon = (coupon) => {
      if (process.env.NODE_ENV == "local") {
        router.push({
          name: "CouponDetailIndex",
          params: { id: coupon.id },
          query: { language: store.getters["common/lang"] },
        });
      } else {
        nativeHandlerService.openCoupon(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-coupons/coupon/${coupon.id}`
        );
      }
    };

    return {
      isReadyToDraw,
      goToCoupon,
      masterCoupon,
      defaultImageUrl,
      isLocal,
    };
  },
};
</script>

<style scoped lang="scss">
.item-container {
  height: 85px;
  max-height: 23vw;
  display: flex;
  flex-direction: row;
}

.item-img {
  width: 65px;
  height: calc(100% - 20px);
  padding: 10px;
}
.item-content {
  overflow: hidden;
  width: calc(100% - 120px);
  position: relative;
  height: 100%;
  padding: 10px 0px;
}

.item-btn {
  width: 35px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
